// @LTG-ID: F-080
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 07_PAGES_AND_ROUTES.md#/contact, 08_FEATURES.md#F-080,
//        source `Contact.html` (v4 v1.1), `README - Contact Page.md`
// @CHANGED: 2026-05 session_006 (CHG-0083-M-A1)
// @OWNER: web
//
// F-080 — `/contact` route. Visual scaffolding port of v4 Contact.html.
//
// Renders inside SiteLayout (Header + Footer global). The v4 source's own
// <header class="site-header"> and <footer class="site-footer"> are NOT
// ported — SiteLayout supplies the chrome (per ADR-008 and existing site
// architecture).
//
// CHG-0083-M-A1 scope (this turn):
//   ✓ 5-step structural port (StepName, StepBusiness, StepEmail, StepCategory,
//     StepDetails) with v4 visual fidelity.
//   ✓ Validators ported verbatim (6 functions, LTG voice error copy).
//   ✓ Proactive ARIA hooks per OQ-V4-6 (aria-required / aria-invalid /
//     aria-describedby / role="alert" / role="progressbar" / role="radiogroup").
//   ✓ Inline error display using CHG-0081 semantic error tokens
//     (--error-bg / --error-line).
//   ✓ Step navigation gated by validation (forward navigation requires
//     { ok: true } across all visible fields).
//   ✓ localStorage draft persistence under key `ltg_contact_v1` (v4 parity).
//
// CHG-0083-M-A1 explicit exclusions (deferred):
//   ✗ Sending animation + Confirmation screen — CHG-0083-M-A2.
//   ✗ <SendingError> 429 UI (OQ-V4-13) — CHG-0083-M-A2.
//   ✗ `000000` sentinel mock for verify step — CHG-0083-M-A2 (this turn
//     accepts ANY 6 digits, matching v4 demo-mode disk truth).
//   ✗ Reference-code generator + URL ?ref=&category= jump-to-confirmation —
//     CHG-0083-M-A2.
//   ✗ Honeypot field (OQ-V4-11) — CHG-0083-M-A3.
//   ✗ GA4 `data-cta-id` attributes — CHG-0083-M-A3.
//   ✗ Backend API wiring (`POST /api/contact`) — CHG-0084 CANCELLED per
//     ADR-032 (app.letstalkgrowth.com does not exist; forwarding logic moves to a
//     future CHG-0107 with app.letstalkgrowth.com destination). LTG-local
//     persistence via CHG-0078 is the shipped surface.

import { useEffect } from "react";
import MultiStepForm from "../components/contact/MultiStepForm";
import "../components/contact/contact-shared.css";

export const ContactPage = () => {
    useEffect(() => {
        document.title =
            "Contact us · Let's Talk Growth by KGOB CPAs & Advisors";
    }, []);

    return (
        <div
            className="ltgc-root"
            data-testid="contact-page"
            data-page="contact"
        >
            <div
                className="ltgc-stage-inner"
                data-testid="contact-stage-inner"
            >
                <MultiStepForm />
            </div>
        </div>
    );
};

export default ContactPage;
